








import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

export const ButtonColors = [
	'none',
	'primary',
	'secondary',
	'tertiary',
	'success',
	'danger',
	'light',
	'medium',
	'dark',
] as const;

@Component({
	name: 'BasicButton',
})
export default class BasicButton extends Vue {
	@Prop({ default: 'secondary', type: String }) color: (typeof ButtonColors)[number];
	@Prop({ default: false, type: Boolean }) bordered: boolean;
	@Prop({ default: true, type: Boolean }) filled: boolean; // whether the background is filled or not
	@Prop({ default: false, type: Boolean }) blocked: boolean;
	@Prop({ default: false, type: Boolean }) uppercase: boolean;
	@Prop({ default: false, type: Boolean }) disabled: boolean;
	@Prop({ default: true, type: Boolean }) rounded: boolean;
	@Prop({ default: 'default', type: String }) size: 'small' | 'default' | 'large' | 'none';

	get classes() {
		return {
			// colors
			primary: this.color === 'primary',
			secondary: this.color === 'secondary',
			tertiary: this.color === 'tertiary' || this.color === 'dark',
			light: this.color === 'light',
			medium: this.color === 'medium',

			// size
			sm: this.size === 'small',
			md: this.size === 'default',
			lg: this.size === 'large',

			border: this.bordered,
			'w-full': this.blocked,
			'bg-none': !this.filled,
			uppercase: this.uppercase,
			rounded: this.rounded,
			disabled: this.disabled,
		};
	}
}
